import { Box, Breadcrumbs, Typography } from '@mui/material';
import { PUCNavLink } from 'Helpers/overrides';
import React from 'react'

const NotificationBreadCrumb = () => {
  return (
    <Box sx={breadboxstyle}>
    <Box>
      <Typography variant="h6">
        Home
      </Typography>
      <Breadcrumbs aria-label="breadcrumb">
        <PUCNavLink
          color="inherit"
          underline="hover"
          to="/admin/home"
          className={
            "breadactive"
          }>
          Home
        </PUCNavLink>
        <PUCNavLink
          className={
            "breadactive"
          }
          underline="hover"
          color="inherit"

          aria-current="page">
          Notification
        </PUCNavLink>
      </Breadcrumbs>
    </Box>
  </Box>
  )
}

const breadboxstyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row"
  };
export default NotificationBreadCrumb
